<div [ngClass]="[cardOrListStyle, statusStyle]"></div>
